module.exports = __webpack_public_path__ + "static/2-6-314ffbf8c61bd8cde0b91d930f2a7b5b.jpg";